<template>
  <header class="training-header">
    <h1 class="training-title">{{ title }}</h1>
    <div class="join-time">{{ startTime | formatTime('yyyy年MM月dd日') }}加入</div>
    <div class="dashboard-block">
      <div class="complete-block"
           v-if="isComplete"
      >
        <svg style="width:0;height:0;position:absolute;" aria-hidden="true" focusable="false">
          <linearGradient id="complete-gradient" x2="1" y2="1">
            <stop offset="0%" stop-color="#00D8C1"/>
            <stop offset="100%" stop-color="#019DE2"/>
          </linearGradient>
        </svg>
        <ym-icon class="icon-complete"
                  name="complete"
        />
        <div class="complete-info">
          <span>恭喜你！</span><br/>
          {{ title }}已完成
        </div>
      </div>
      <template v-else>
        <dashboard :finish-count="finishCount"
                   :continue-count="continueCount"
                   :read-count="readCount"
        />
        <div class="process-container">
          <div class="finished-process"
               :style="{ 'width': finishedProcess + '%' }"
          ></div>
        </div>
      </template>
    </div>
  </header>
</template>

<script>
  import Dashboard from '@/pages/Training/components/TrainingDashboard';

  export default {
    name: 'TrainingDetailJoinedHeader',
    components: {
      Dashboard,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      startTime: {
        type: Number,
        required: true,
      },
      isComplete: {
        type: Boolean,
        required: true,
      },
      finishCount: {
        type: Number,
        required: true,
      },
      continueCount: {
        type: Number,
        required: true,
      },
      readCount: {
        type: Number,
        required: true,
      },
      levelsLength: {
        type: Number,
        required: true,
      },
    },
    computed: {
      finishedProcess() {
        if (this.levelsLength === 0) return 0;
        return (this.finishCount / this.levelsLength) * 100;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  @import '~@/assets/styles/mixins.less';

  .training-header {
    height: 340px;
    padding-top: 60px;
    color: @color-white;
    text-align: center;
    margin-bottom: 108px;
    box-sizing: border-box;
    overflow: visible;
    .training-gradient-primary();
  }

  .training-title {
    font-size: @font-size-extra-extra-large;
    font-weight: @font-weight-primary;
    margin: 0 auto @size-small;
  }

  .join-time {
    color: @training-text-white-lighter;
    font-weight: @font-weight-light;
    font-size: @font-size-small;
    margin-bottom: @size-base;
  }

  @dashboard-padding: @size-base;
  .dashboard-block {
    position: relative;
    height: 230px;
    overflow: hidden;
    padding: @dashboard-padding;
    background-color: @color-white;
    border-radius: @border-radius-medium;
    margin: 0 @size-base;
    box-shadow: @training-box-shadow-lighter;
    box-sizing: border-box;
  }

  @process-height: 10px;
  .process-container {
    width: 100%;
    height: @process-height;
    margin-top: @size-medium;
    background-color: @training-primary-color-lighter;
    border-radius: @process-height / 2;
    position: relative;
  }

  .finished-process {
    height: @process-height;
    border-radius: @process-height / 2;
    .training-gradient-primary();
  }

  .complete-block {
    position: absolute;
    left: @dashboard-padding;
    right: @dashboard-padding;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    color: @color-text-base;
    .icon-complete {
      font-size: 202px;
      margin-right: @size-extra-small;
      flex-shrink: 0;
      fill: url('#complete-gradient');
    }
  }

  .complete-info {
    text-align: left;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    line-height: 1.6;
    word-break: break-all;
    span {
      font-size: @font-size-extra-large;
    }
  }

</style>
